import React from "react";

const badge = "inline-flex items-center max-w-[220px] truncate px-2 py-0.5 rounded-md text-xs font-medium border";

function freightOrderStatusHexColorCell(value) {
  const hex = value != null ? String(value).trim() : "";
  if (!hex) return <span className="text-gray-400">—</span>;
  return (
    <div className="flex items-center gap-2 min-w-0">
      <span
        className="h-9 w-14 shrink-0 rounded-md border border-gray-300 shadow-sm"
        style={{ backgroundColor: hex }}
        title={hex}
        aria-hidden
      />
      <code className="text-xs font-mono text-gray-800 truncate">{hex}</code>
    </div>
  );
}

export function freightOrderStatusActiveCell(row) {
  const on = String(row?.status) === "1";
  return (
    <span className={`${badge} ${on ? "border-emerald-200 bg-emerald-50 text-emerald-900" : "border-gray-200 bg-gray-50 text-gray-600"}`}>
      {on ? "Active" : "Inactive"}
    </span>
  );
}

export function freightOrderStatusTextColorCell(row) {
  return freightOrderStatusHexColorCell(row?.text_color);
}

export function freightOrderStatusBackgroundColorCell(row) {
  return freightOrderStatusHexColorCell(row?.background_color);
}

export const FREIGHT_ORDER_STATUS_MASTER_COLUMNS = [
  { key: "id", label: "ID", aliases: [], defaultVisible: false },
  { key: "name", label: "Name", aliases: [], defaultVisible: true },
  { key: "sub_status", label: "Sub status", aliases: [], defaultVisible: true },
  {
    key: "text_color",
    label: "Text color",
    aliases: [],
    defaultVisible: true,
    sortable: false,
    renderCell: freightOrderStatusTextColorCell
  },
  {
    key: "background_color",
    label: "Background color",
    aliases: [],
    defaultVisible: true,
    sortable: false,
    renderCell: freightOrderStatusBackgroundColorCell
  },
  { key: "order_no", label: "Order", aliases: ["orderNo"], defaultVisible: true },
  {
    key: "status",
    label: "Status",
    aliases: [],
    defaultVisible: true,
    sortable: false,
    renderCell: freightOrderStatusActiveCell
  }
];
